module.exports = __webpack_public_path__ + "resources/icon_32_right_arrow.4ff50bf69132d746.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/strategy-lib-dialog/img/icon_32_right_arrow.png
// module id = 605
// module chunks = 0 1 2 3